"use client";

import type { NodeVideoPlayer } from "./shallow-types";

import { useEffect, useState } from "react";
import ReactPlayer from "react-player";

export const ShallowVideoPlayer = ({
  url,
}: Omit<NodeVideoPlayer, "nodeType">) => {
  const [isMounted, setIsMounted] = useState(false);

  // wait for mount to render React Player to avoid hydration mismatch
  useEffect(() => {
    // TODO stop suppressing this warning (don't replicate this!)
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsMounted(true);
  }, []);

  return (
    <div className="mx-auto w-full max-w-3xl px-4 sm:px-14 lg:px-0 xl:max-w-4xl">
      <div className="relative mx-auto aspect-[16/9]">
        {isMounted ? (
          <ReactPlayer
            controls={true}
            height={"100%"}
            src={url}
            width={"100%"}
          />
        ) : (
          // Placeholder with same dimensions for SSR
          <div className="h-full w-full bg-gray-200" />
        )}
      </div>
    </div>
  );
};
